import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

export interface FmsCustomerItem {
    label: string
    customerNumber: string
    id: string
}

class FmsCustomerStore {
    get items(): FmsCustomerItem[] {
        return this._items;
    }

    set items(value: FmsCustomerItem[]) {
        this._items = value;
    }

    private _items: FmsCustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<FmsCustomerItem[]> {
        const response = await catchApi(async () => api.fms.api.findCustomers({query: query}))
        return (response?.data || []).map(item => ({
            label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
            customerNumber: `${item.customerNumber}`,
            id: `${item.customerId}`
        }))
    }

    async init() {
        if (!this.items.length) {
            await this.load()
        }
    }

    async load() {
        const response = await catchApi(async () => api.fms.api.findCustomers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }

}

const fmsCustomerStore = new FmsCustomerStore()

export {
    fmsCustomerStore
}
